import './articles.scss';

import React from 'react';

import ArticleSingle from './ArticleSingle';

export default function Articles(props: { articles: any[] }) {
    return (
        <div className='articlesBlock'>
            <div className='container'>
                <div className='row'>
                    {props.articles.map((article, index) => {
                        return <ArticleSingle article={article} key={index} />;
                    })}
                </div>
            </div>
        </div>
    );
}
